import { Icon } from "components/index";
import React from "react";
import { FOLDER } from "icons";
import { useLocation, useNavigate } from "react-router-dom";


export default function FolderListItem({ folder }) {
  if (!folder) return null;
  const location = useLocation();
  const navigate = useNavigate();

  const openFolder = () => {
    navigate(`${location.pathname}/${folder.id}`);
  };
  return (
    <div
      onClick={openFolder}
      className="flex items-center gap-4 p-2 border-b border-border hover:bg-muted/50 transition-colors cursor-pointer"
    >
      <div className="flex-shrink-0">
        <div className="size-8 bg-muted border border-border rounded-lg overflow-hidden flex items-center justify-center">
          <Icon icon={FOLDER} className="size-4 text-gray-500" />
        </div>
      </div>
      <div className="flex-1 min-w-0">
        <div className="text-sm font-medium truncate">{folder.name}</div>
      </div>
    </div>
  );
}
